import Loader from "react-loader-spinner";

const FlyerModal = ({ url, id, updateStatus, loading }) => (
    <div style={{ position: "fixed", zIndex: 1051, left: "40%" }}>
      <div>
        <div
          className="modal"
          style={{
            display: "block",
            alignItems: "center",
          }}
        >
          <div
            className="modal-dialog"
            style={{ maxWidth: "300px", left: "-10%", top: "10%" }}
          >
            <div
              className="modal-content"
              style={{ maxWidth: "300px", left: "40%", top: "30%", maxHeight: "550px" }}
            >
              <div className="modal-body">
                <div className="d-flex" style={{ justifyContent: "end" }}>
                  {loading ? <Loader type="Oval" color="#2d207d" height="20px" width="20px" /> : <img
                    src="/Assets/remove.svg"
                    height="25px"
                    width="25px"
                    style={{ marginBottom: "5px", cursor: "pointer" }}
                    onClick={() => updateStatus(id)}
                    alt="close icon"
                  />}
                </div>
                <div className="d-flex" style={{ justifyContent: "center"}}>
                  <img 
                    src={url} 
                    style={{maxHeight:"400px", maxWidth:"250px", paddingBottom: "10px"}} 
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="modal-backdrop show"></div>
      </div>
    </div>
  );

export default FlyerModal;
